import React from "react";
import { DialogMain } from "./styles/DialogStyles";
import { DialogContent } from "@mui/material";
import {
  PrintInvoicesMain,
  InvoicesHeader,
  InvoicesHeaderDetails,
  WeekDetails,
  ToDetails,
  HozLine,
  DescriptionList,
  ListItems,
  TotalPrice,
  Footer,
} from "./styles/PrintInvoicesStyles";

function PrintInvoices({ open, handleClose }) {
  return (
    <PrintInvoicesMain>
      <DialogMain
        open={open}
        onClose={handleClose}
        jobPopup={true}
        className="PrintInvoicesModel"
        sx={{
          "& .MuiDialog-paper": {
            width: "500px",
          },
        }}
      >
        <DialogContent>
          <InvoicesHeader>
            <h6>Techify</h6>
            <h6 className="invoice_Tit">INVOICE</h6>
          </InvoicesHeader>
          <InvoicesHeaderDetails>
            <div className="details">
              <p>
                103 Channing Drive Bear, DE 19701 302-414-0980
                GCraig@Nadinelogistics.com
              </p>
            </div>
            <div className="data">
              <p>INVOICE # 63 </p>
              <p>
                <span>DATE </span>
                3/16/23
              </p>
            </div>
          </InvoicesHeaderDetails>
          <WeekDetails>
            <p>
              <span>Week: </span>Racing From
            </p>
            <p> 2/27/23 - 3/5/23</p>
          </WeekDetails>
          <ToDetails>
            <h6>To</h6>
            <p>Bruce McCray Now Logistics Transportation</p>
          </ToDetails>
          <HozLine />
          <DescriptionList>
            <div className="descTit">
              <h6>Description</h6>
              <h6>Amount</h6>
            </div>
          </DescriptionList>
          <ListItems>
            <h6>4- Boston route</h6>
            <h6>$1,960</h6>
          </ListItems>
          <ListItems>
            <h6>4- conn route</h6>
            <h6>$1,960</h6>
          </ListItems>
          <ListItems>
            <h6>4- albany route</h6>
            <h6>$900</h6>
          </ListItems>
          <TotalPrice>
            <h6 className="total">total</h6>
            <h6 className="price">$6,647.50</h6>
          </TotalPrice>
          <Footer>
            <p>
              If you have any questions concerning this invoice, contact Garel
              Craig | 302-414-0980 | GCraig@Nadinelogistics.com
            </p>
          </Footer>
        </DialogContent>
      </DialogMain>
    </PrintInvoicesMain>
  );
}

export default PrintInvoices;
